import { Route, Switch } from 'react-router-dom'
import { useUserContext } from "../components/contexts/useUserContext";

import Retailersdashboard from '../pages/RetailersDashboard'
import RetailerReports from '../pages/RetailersDashboard/RetailerReports'
import Qrcodepage from '../pages/RetailersDashboard/QrPage'
import Sidebar from '../components/SidebarRetailer';
import RetailerGuide from '../pages/RetailersDashboard/RetailerGuide';

const RetailerRoutes = () => {
    const { user } = useUserContext()

    return (
        <Switch>
            {
            user && user.type === 'retailer'  ?
            <>
                <Route exact path='/retailersdashboard'>
                    <Sidebar />
                    <Retailersdashboard />
                </Route>
                <Route exact path='/retailernewuser'>
                    <Sidebar />
                    <Qrcodepage />
                </Route>
                <Route exact path='/retailerreports'>
                    <Sidebar />
                    <RetailerReports />
                </Route>
                <Route exact path='/profile'>
                    <Sidebar />
                </Route>
                <Route exact path='/guia-revendedor'>
                    <Sidebar />
                    <RetailerGuide />
                </Route>
            </>
            :
            ''}
        </Switch>
    )
}

export default RetailerRoutes
